import { useEffect, useState } from 'react';
import CustomProvider from 'components/CustomProvider';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import classNames from 'classnames';
import Button from '@alltrails/shared/denali/components/Button';
import logProfileViewed from '@alltrails/analytics/events/logProfileViewed';

import refreshUser from 'api/User';
import logError from 'utils/logError';

import * as styles from './styles/styles.module.scss';

type Props = {
  userId: number | string;
  editProfilePath: string;
  publicProfile: boolean;
  adminUser: boolean;
  adminRemoveProfilePath: string;
};

const UserProfileHeader = ({ userId, editProfilePath, publicProfile, adminUser, adminRemoveProfilePath }: Props): JSX.Element => {
  const [refreshString, setRefreshString] = useState('Refresh user');

  useEffect(() => {
    if (publicProfile) {
      logProfileViewed({ owned_by_user: false, owner_id: userId as string });
    } else {
      logProfileViewed({ owned_by_user: true, owner_id: userId as string });
    }
  }, []);

  const refreshUserRequest = () => {
    refreshUser(userId as string)
      .then(() => setRefreshString('Refreshed'))
      .catch(logError);
  };
  return (
    <CustomProvider>
      <div className={styles.profileHeader}>
        <h3>
          <FormattedMessage defaultMessage="Profile" />
        </h3>
        {!publicProfile && (
          <Button
            text={<FormattedMessage defaultMessage="Edit profile" />}
            className={styles.link}
            linkInfo={{ href: editProfilePath }}
            testId="editProfile"
          />
        )}
        {publicProfile && adminUser && (
          // we don't need to translate the admin strings
          <div>
            <Button
              text="Delete profile"
              className={classNames(styles.link, styles.deleteProfile)}
              linkInfo={{ href: adminRemoveProfilePath }}
              testId="deleteProfile"
            />
            <Button text={refreshString} className={styles.link} onClick={refreshUserRequest} testId="refreshUser" />
          </div>
        )}
      </div>
    </CustomProvider>
  );
};

export default UserProfileHeader;
